var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAddLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12a9.6 9.6 0 1 0-19.2 0M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12M2.4 12a9.6 9.6 0 1 0 19.2 0m2.4 0c0 6.627-5.373 12-12 12S0 18.627 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.03 6.99v3.98h3.98c.526 0 .96.393 1.023.9l.008.13a1.03 1.03 0 0 1-1.03 1.03h-3.98v3.98a1.03 1.03 0 1 1-2.061 0v-3.98H6.99a1.03 1.03 0 0 1-1.023-.9L5.96 12c0-.569.461-1.03 1.03-1.03h3.98V6.99a1.03 1.03 0 0 1 2.061 0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAddLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-add-light.e67c3605f115b71900b89734d253181a.svg";